/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import { webApi } from '../../lib/WebApi'

export const defaultState = {
    currentTeamId: null,
    currentTeam: null,
    divisions: [],
    user: null,
    loading: false,
    loggingInUser: false,
    loggingInTeam: false,
    isUserLoggedIn: null,
    isTeamLoggedIn: null
}

export function loginUser(email, password, cb) {
    return dispatch => {
        webApi.userLogin({ email, password})
            .then(json => {
                if (cb) { cb(true, null) }
            })
            .catch(err => {
                if (cb) { cb(null, err) }
            })
    }
}

export function loginUserByCode(userId, code, cb) {
    return dispatch => {
        webApi
            .loginByCode(userId, code)
            .then(json => {
                if (cb) { cb(true, null) }
                dispatch({type: 'COMMON_RESET' })
            })
            .catch(err => {
                if (cb) { cb(null, err) }
            })
    }
}

export function sendMagicLink(email, link, cb = null) {
    return dispatch => {
        let params = {
            email: email,
            // eslint-disable-next-line no-template-curly-in-string
            proceed_url: 'https://go.traceup.com/mischief/managed/userid/${userId}/token/${token}'
        }
        if (link) {
            params.proceed_url = link
        }
        webApi._post('/webapp/autologin-url/send', params)
            .then(json => {
                if (cb) { cb(true, null) }
            })
            .catch(err => {
                console.log('sendMagic error', err)
                if (cb) { cb(false, err) }
            })
    }
}
